
export const APP_ROUTES = {
    MAIN: '/',
    SEARCH: '/search',
    LOGIN: '/login',
    POST: '/news',
    STORY_ADD: '/news/add',
    REACTION: '/opinion',
    REACTION_ADD: '/opinion/add',
    REACTION_EDIT: '/opinion',
    USER: '/user',
    USER_SETTINGS: '/user/settings',
    USER_FOLLOWERS: '/followers',
    USER_FOLLOWING: '/following',
    USER_CONTROL: '/user/control',
    PAGE404: '/404',
    PAGE403: '/403',
    NEWSAPP: '/newsapp',
    STATIC: '/static',
};

export const REACTION_EMPTY = {
    id: 0, 
    scope: 0, 
    story: {id: 0, title: ''}, 
    text_msg: '', 
    text_msg_translation: '', 
    language: {}, 
    user: {
        id: 0
    },
    like_you: false,
    like_count: "",
    text_status: ""
};
